import React, { useState, useContext, useEffect } from "react";
import { useParams, NavLink } from "react-router-dom";
import { AppStateContext, AppConfig } from "../../../app-state";
import { AppLoad } from "../../../core/AppLoad";
import { Spinner } from "../../../core/Spinner";
import { Header } from "./Header";
import { EventGallery } from "./EventGallery";
import { Intel } from "./Intel";
import { Wall } from "./Wall";
import { phpBool } from "../../../core/Helpers";
import { EnrollmentProgress } from "./EnrollmentProgress";
import { AttachedDocs } from "./AttachedDocs";
import { Attendees } from "./Attendees";
import { getEventState, EEventTimeState } from "../../common/event/EventHelper";
import { MoneyStr } from "../../../core/Money";
const bidErrorsDictionary = {
    bid_too_high: "Příhoz je příliš vysoký",
    bid_too_low: "Příhoz je příliš nízký",
    "price-mismatch": "Někdo byl rychlejší. Vaše nabídka již není aktuální, prosím nabídněte novou cenu.",
    "price-mismatch-fb": "Někdo byl rychlejší. Vaše nabídka již není aktuální, prosím nabídněte novou cenu.",
    "no_event": "no_event",
    "event_ended": "Aukce již skončila",
};
export const EventDetail = () => {
    const [eventData, setEventData] = useState(null);
    const [eventState, setEventState] = useState(null);
    const [attendees, setAttendees] = useState(null);
    const [enrollment, setEnrollment] = useState(null);
    const [imageData, setImageData] = useState(null);
    const [docData, setDocData] = useState(null);
    const [loadState, setLoadState] = useState('firstLoad'); // firstLoad | loading | loaded
    const [bidState, setBidState] = useState('awaiting'); // awaiting |  | 
    const [bidValue, setBidValue] = useState('');
    const [eventActions, setEventActions] = useState([]);
    // const [actionCheck, setActionCheck] = useState<number>(0);
    const [lastTimelineStamp, setLastTimelineStamp] = useState(99);
    const [lastTimelineRefresh, setLastTimelineRefresh] = useState(1);
    const { urlEventId } = useParams();
    const { state, dispatch } = useContext(AppStateContext);
    const editUrl = "/cs/proces/editovat-aukci/" + urlEventId;
    var refreshInterval;
    const loadEventDetails = () => {
        AppLoad(AppConfig.APIUrl + 'public/events/detail', { eventId: urlEventId }).then((Response) => {
            if (Response.status == 'error') {
                alert(Response.message);
            }
            else if (Response.status == 'ok') {
                setEventData(Response.data);
                setEventState(getEventState(Response.data));
                setImageData(Response.imageData);
                setDocData(Response.docData);
                setAttendees(Response.attendees);
                setEnrollment(Response.enrollment);
                setBidValue(Response.data.bid_increase);
                setLoadState('loaded');
            }
        });
    };
    const loadEventActions = () => {
        if (lastTimelineRefresh > 1 && eventState && (eventState.timeState == EEventTimeState.Closed))
            return; //no 
        if (lastTimelineRefresh > 1 && eventState && (eventState.timeState == EEventTimeState.ToBe))
            return; //no 
        AppLoad(AppConfig.APIUrl + 'public/events/actions', { eventId: urlEventId, asat: lastTimelineStamp }).then((Response) => {
            if (Response.status == 'error') {
                alert(Response.message);
            }
            else if (Response.status == 'ok') {
                setEventActions(Response.Actions);
                setEventData(Response.EventData);
                setLastTimelineStamp(Response.asat);
            }
            else if (Response.status == 'no-change') {
                //no update needed
            }
        });
    };
    const tryBid = (e, preemptive) => {
        e.preventDefault();
        setBidState('trying');
        const realBidValue = Number(eventData.price ? (phpBool(preemptive) ? 0 : bidValue) : 0);
        const realPrice = Number(eventData.price ? eventData.price : eventData.lowest_bid);
        if (!confirm("V aukci číslo jednací " + eventData.refno + " nabízíte " + MoneyStr(realBidValue + realPrice)))
            return false;
        AppLoad(AppConfig.APIUrl + 'secured/event/bid', {
            eventId: urlEventId,
            value: realBidValue,
            price: realPrice
        }).then((Response) => {
            if (Response.status == 'error') {
                alert(bidErrorsDictionary[Response.message]);
            }
            else if (Response.status == 'ok') {
                // dispatch({ type: 'appReload' });
            }
            setBidState('idle');
        });
    };
    // useEffect(, []);
    useEffect(() => {
        loadEventDetails();
        refreshInterval = setInterval(() => {
            setLastTimelineRefresh(lastTimelineRefresh => lastTimelineRefresh + 1);
        }, 3000);
        return () => clearInterval(refreshInterval);
    }, []);
    useEffect(() => loadEventActions(), [lastTimelineRefresh]);
    return (React.createElement("div", { className: "event-detail" }, loadState == 'firstLoad' ?
        React.createElement(Spinner, { large: true })
        :
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "navbar" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "navbar-inner" },
                            React.createElement(NavLink, { to: eventState.listUrl, className: "back-link" },
                                React.createElement("span", { className: "icon", "aria-hidden": true }),
                                React.createElement("span", { className: "text" }, eventState.title))))),
                eventData.status == 'cancelled' ? React.createElement("div", { className: "container pt-48" },
                    React.createElement(Header, { title: eventData.title, role: state.user.role, editUrl: editUrl, refno: eventData.refno }),
                    "Aukce byla zru\u0161ena")
                    :
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "ed-hero" },
                                React.createElement("div", { className: "container" },
                                    React.createElement(Header, { title: eventData.title, role: state.user.role, editUrl: editUrl, refno: eventData.refno }),
                                    React.createElement(EnrollmentProgress, { enrollment: enrollment }),
                                    React.createElement("div", { className: "ed-main" },
                                        React.createElement("div", { className: "ed-gallery" },
                                            React.createElement(EventGallery, { imageData: imageData })),
                                        React.createElement("div", { className: "ed-intel" },
                                            React.createElement(Intel, { eventState: eventState, eventData: eventData, urlEventId: urlEventId, enrollment: enrollment, bidState: bidState, tryBid: tryBid, bidValue: bidValue, setBidValue: setBidValue }))))),
                            React.createElement("div", { className: "container" },
                                React.createElement("div", { className: "ed-progress" },
                                    React.createElement("div", { className: "ed-wall" },
                                        React.createElement(Wall, { eventActions: eventActions, eventData: eventData })),
                                    React.createElement("div", { className: "ed-aside" },
                                        React.createElement(Attendees, { attendees: attendees, eventData: eventData }),
                                        React.createElement(AttachedDocs, { docData: docData }))))))));
};
